$(document).on "turbolinks:load", ->
  setTimeout ->
    $(document).find("div[class^='flash__container']").fadeOut()
  , 6000

  $(document).on "click", ".flash__delete", ->
    $(this).parent().fadeOut()
